export default {
  address: 'Dirección',
  contact: 'Contacto',
  terms: 'Condiciones de uso',
  privacy_policy: 'Política de privacidad',
  impressum: 'Impressum',
  cookie_policy: 'Política de cookies',
  cookie_settings: 'Configuración de cookies',
};
